(function(){

	class WinController{
		constructor(){
			this._batcher = undefined;
			this._winlineAnimator = undefined;
			this._symbolAnimator = undefined;
			this._winTextAnimator = undefined;
			this._active = false;
			this._skipped = false;
			this._currentSequence = 0;
			this._sequencePaused = false;
			this._completeCallback = undefined;
			this._sequenceData = [];
			this._winData = undefined;
			this._sequenceStartCb = undefined;
			this._sequenceCompleteCb = undefined;
			this._slotMachine = undefined;
		}

		initialise(json){
			if (gdk.mustShowSlowWin()){
				this._batcher = resourceManager.getSharedPlugin(json.batcher_slow);
			}
			else{
				this._batcher = resourceManager.getSharedPlugin(json.batcher_normal);
			}
			this._symbolAnimator = json.symbolAnimator ? resourceManager.get(json.symbolAnimator) : undefined;
			this._winlineAnimator = json.winlineAnimator ? resourceManager.getSharedPlugin(json.winlineAnimator) : undefined;
			this._winTextAnimator = json.winTextAnimator ? resourceManager.get(json.winTextAnimator) : undefined;
		}

		getWinningLinesInSequence(winData, sequence){
			let linesToPlay = [];
			for (let i = 0; i < sequence.length; ++i){
				linesToPlay.push(sequence[i].winline);
			}

			let uniqueArray = linesToPlay.filter(function(item, pos) {
				return linesToPlay.indexOf(item) == pos;
			});

			let res = [];
			for (let i = 0; i < winData.winningLines.length && (res.length < uniqueArray.length); ++i){
				if (uniqueArray.indexOf(winData.winningLines[i].winningLine) !== -1){
					res.push(winData.winningLines[i]);
				}
			}

			return res;
		}

		animateWinText(totalValue, time){
			if (this._winTextAnimator){
				this._winTextAnimator.countTo(totalValue, time);
			}
		}


		playSequence(winData, sequence, slotMachine, onSquenceComplete){
			let self = this;

			// set the callback guards to be set to false if there is an animation to play, otherwise they will be true meaning we can move on
			let hasWinlineSequence = sequence.animationTypes.indexOf("Winline") !== -1;
			let hasSymbolSequence = sequence.animationTypes.indexOf("Symbol") !== -1;
			let hasCounterSequence = sequence.animationTypes.indexOf("Counter") !== -1;
			let winlineComplete = !this._winlineAnimator || !hasWinlineSequence;
			let symbolComplete = !this._symbolAnimator || !hasSymbolSequence;

			let checkForSequenceComplete = function(){
				if(winlineComplete && symbolComplete){
					onSquenceComplete();
				}
			}

			let winlines = [];
			if (this._winlineAnimator && hasWinlineSequence){

				if (this._winTextAnimator && hasCounterSequence){
					this.animateWinText(sequence.counterData, this._winlineAnimator.WINLINE_ANIMATION_TIME * sequence.data.length);
				}

				winlines = this.getWinningLinesInSequence(winData, sequence.data);
				this._winlineAnimator.playAnimations(winlines,function(){
					if (self._winTextAnimator && hasCounterSequence){
						self._winTextAnimator.jumpToTarget();
					}
					winlineComplete = true;
					checkForSequenceComplete();
				},false, false);
			}

			if (this._symbolAnimator && hasSymbolSequence){

				// check for sound to play
				if (sequence.data.length > 0){
					// If this does not have a winID (e.g. groups with multiple symbols in) dont play a sound
					let winId = sequence.data[0].winId;
					if (winId) {
						let symbolTemplate = resourceManager.getConfiguration().symbols[ Object.keys(resourceManager.getConfiguration().symbols)[winId] ];
						if (typeof(symbolTemplate.soundFile) !== "undefined") {
							// Single sound for all wins on this winline
							soundManager.play(symbolTemplate.soundFile);
						}
					}
				}

				// if we are not animating winlines, just symbol animations, then we need to show the win text here
				// otherwise nothing tells it to animate
				if (this._winTextAnimator && hasCounterSequence){
					this.animateWinText(sequence.counterData, this._winlineAnimator.WINLINE_ANIMATION_TIME * sequence.data.length);
				}


				this._symbolAnimator.animateSymbols(sequence.data, slotMachine, this._canCelebrate, false, function(){
					if (self._winTextAnimator && hasCounterSequence){
						self._winTextAnimator.jumpToTarget();
					}
					symbolComplete = true;
					checkForSequenceComplete();
				});
			}
		}

		playNextSequence(){
			let self = this;

			if (self._sequenceStartCb)
				self._sequenceStartCb(self._sequenceData[self._currentSequence]);

			self.playSequence(self._winData, self._sequenceData[self._currentSequence], self._slotMachine, function(){
				if (self._sequenceCompleteCb)
					self._sequenceCompleteCb(self._sequenceData[self._currentSequence]);

				if (!self._sequencePaused){
					self.stepToNextSequence();
				}
			});
		}

		stepToNextSequence(){
			let self = this;
			++self._currentSequence;
			if (self._currentSequence >= self._sequenceData.length || self._skipped){
				if (self._winTextAnimator)
					self._winTextAnimator.jumpTo(self._winData.totalLineWinnings);
				self._active = false;
				self._sequencePaused = false;
				self._sequenceData = [];
				self._winData = undefined;
				self._sequenceStartCb = undefined;
				self._sequenceCompleteCb = undefined;
				self._slotMachine = undefined;
				if (self._completeCallback){
					let cb = self._completeCallback;
					self._completeCallback = undefined;
					cb();
				}
			}
			else{
				this.playNextSequence();
			}
		}


		startAnimations(winData, celebrationThreshold, slotMachine,  completeCallback, sequenceStart, sequenceComplete){
			let self = this;
			self._active = true;

			this._canCelebrate = winData.totalLineWinnings > celebrationThreshold;
			this._sequencePaused = false;
			this._sequenceStartCb = sequenceStart;
			this._sequenceCompleteCb = sequenceComplete;
			this._winData = winData;
			this._sequenceData = this._batcher.batch(this._winData, this._canCelebrate);
			this._currentSequence = 0;
			this._skipped = false;
			this._completeCallback = completeCallback;
			this._slotMachine = slotMachine;

			this.playNextSequence();
		}

		isActive(){
			return this._active;
		}

		skipAnimations(){
			if (this.isActive()){
				this._sequencePaused = false;
				this._skipped = true;
				this._symbolAnimator.skip();
				if (this._winlineAnimator)
					this._winlineAnimator.skipAnimation();

			}
		}

		tidy(){
			if (this._winTextAnimator)
				this._winTextAnimator.finish();
		}

		pauseSequence(){
			this._sequencePaused = true;
		}

		resumeSequence(){
			this._sequencePaused = false;
			this.stepToNextSequence();
		}
	};

	let createWinController = function(){
		return new WinController();
	}


	resourceManager.registerController("WinControllerEx", createWinController);
}());